import { render, staticRenderFns } from "./TemplateLoading.vue?vue&type=template&id=664caee7&scoped=true&"
import script from "./TemplateLoading.vue?vue&type=script&lang=js&"
export * from "./TemplateLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664caee7",
  null
  
)

export default component.exports